module.exports = __webpack_public_path__ + "img/mbq.e65176f4.png";